import { render } from "./card1.vue?vue&type=template&id=c155f2a0"
import script from "./card1.vue?vue&type=script&lang=js"
export * from "./card1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__